module.exports = __webpack_public_path__ + "static/media/payx.5b6325c2.svg";